import { Button } from "@admin/components/ui/button";
import { Input } from "@admin/components/ui/input";

export type RangePreset = "1d" | "7d" | "30d" | "custom";

export function isoRangeForPreset(
  preset: Exclude<RangePreset, "custom">,
  now = new Date(),
): { from: string; to: string } {
  const days = preset === "1d" ? 1 : preset === "7d" ? 7 : 30;
  return {
    from: new Date(now.getTime() - days * 24 * 60 * 60_000).toISOString(),
    to: now.toISOString(),
  };
}

export function RangePicker({
  preset,
  customFrom,
  customTo,
  onPreset,
  onCustomFrom,
  onCustomTo,
}: {
  preset: RangePreset;
  customFrom: string;
  customTo: string;
  onPreset: (preset: RangePreset) => void;
  onCustomFrom: (value: string) => void;
  onCustomTo: (value: string) => void;
}) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="flex flex-wrap gap-1">
        {(["1d", "7d", "30d", "custom"] as const).map((p) => (
          <Button
            key={p}
            type="button"
            size="sm"
            variant={preset === p ? "default" : "outline"}
            onClick={() => onPreset(p)}
          >
            {p === "custom" ? "Custom" : p}
          </Button>
        ))}
      </div>
      {preset === "custom" ? (
        <>
          <label className="flex flex-col gap-1 text-xs text-muted-fg">
            From
            <Input
              type="date"
              value={customFrom}
              onChange={(e) => onCustomFrom(e.target.value)}
              className="h-9"
            />
          </label>
          <label className="flex flex-col gap-1 text-xs text-muted-fg">
            To
            <Input
              type="date"
              value={customTo}
              onChange={(e) => onCustomTo(e.target.value)}
              className="h-9"
            />
          </label>
        </>
      ) : null}
    </div>
  );
}
